module.exports = __webpack_public_path__ + "static/20-70b3ed7be1057f2a82e1f2a206d15e15.jpg";